import React, { Component } from "react";
import "../assets/topo.module.css";
import "../assets/topo.module.off.css";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Dropdown } from "semantic-ui-react";
import "../assets/menu_porta.css";
import { changeAbaNode } from "../main/home/homeActions";
import { producaov2 as apivoitto, producaov2 } from "../services/apis";
import { IS_ADMIN, IS_EMPRESA, IS_EMPRESA_SET } from "../services/auth";
import {
  getUserNode,
  isAuthenticatedNode,
  logoutNode,
} from "../services/auth_node";
import { abrevia_nome, verify_mobile } from "../utils/Utils";
import limpar_titulo from "../utils/home_functions/limpar_titulo";
import separa_em_area_corporativa from "../utils/home_functions/separa_em_area_corporativa";
import TopoMobileNode from "./TopoMobileNode";
import VoittoCoins from "./VoittoCoinsNode";

import styled from "styled-components";
import NotificationsBlock from "./NotificationsBlock";

import { FaBell } from "react-icons/fa";

class Topo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      notSeenQuestion: 0,
      open_menu: true,
      load: false,
      width: "-1%",
      display: "none",
      actCategorias: false,
      cursosByCat: false,
      cursos: [],
      LoginCat: false,
      LoginSub: true,
      openSub: true,
      menu_categoria: 0,
      unreadedNotifications: 0,
      notificationsBlock: false,
      categorias: [
        {
          name: "Lean Seis Sigma",
          icon: "https://files.voitto.com.br/icon-lean.png",
          id: 1,
          area: "lean-seis-sigma",
        },
        {
          name: "Excelência Operacional",
          icon: "https://files.voitto.com.br/icon-excelencia.png",
          id: 2,
          area: "excelencia-operacional",
        },
        {
          name: "Softwares de Gestão",
          icon: "https://files.voitto.com.br/icon-softwares.png",
          id: 3,
          area: "softwares-de-gestao",
        },
        {
          name: "Sistemas de Gestão",
          icon: "https://files.voitto.com.br/icon-sistemas.png",
          id: 4,
          area: "sistemas-de-gestao",
        },
        {
          name: "Inovação & Cultura Ágil",
          icon: "https://files.voitto.com.br/icon-inovacao.png",
          id: 5,
          area: "inovacao-e-cultura-agil",
        },
        {
          name: "Desenvolvimento de Líderes",
          icon: "https://files.voitto.com.br/icon-lideres.png",
          id: 6,
          area: "desenvolvimento-de-lideres",
        },
        {
          name: "Negociação e Vendas",
          icon: "https://files.voitto.com.br/icon-negociacao.png",
          id: 7,
          area: "negociacao-e-vendas",
        },
        {
          name: "Gerenciamento de Projetos",
          icon: "https://files.voitto.com.br/icon-projetos.png",
          id: 9,
          area: "gerenciamento-de-projetos",
        },
      ],
    };
    this.activeCategorias = this.activeCategorias.bind(this);
    this.inactiveCategorias = this.inactiveCategorias.bind(this);
    this.activeCursosByCat = this.activeCursosByCat.bind(this);
    this.inactiveCursosByCat = this.inactiveCursosByCat.bind(this);
    this.renderLoginCat = this.renderLoginCat.bind(this);
    this.activeLogin = this.activeLogin.bind(this);
    this.inactiveLogin = this.inactiveLogin.bind(this);
  }
  loadingRecomendados() { }

  async inMouseInside(isEnter, area) {
    if (isEnter && !this.state.cursos.length) {
      const response = await apivoitto.get(`curso/area`);
      this.setState({ cursos: response.data });
    }
  }

  handleSignOut() {
    logoutNode();
  }

  renderCategorias() {
    return this.state.categorias.map((v) => (
      <div
        onClick={() => window.open(`/cursos/${v.area}`, "_blank")}
        className={"divCategoria"}
        onMouseOver={() => this.activeCursosByCat(v.id)}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          backgroundColor:
            this.state.menu_categoria == v.id ? "#f7f8fa" : "#FFF",
        }}
      >
        <div style={{ height: 20, width: "8%" }}>
          <img src={v.icon} style={{ width: 20, height: "100%" }} />
        </div>
        <div
          className="name-category"
          onMouseEnter={() => this.inMouseInside(true, v.id)}
          onMouseLeave={() => this.inMouseInside(false, 0)}
        >
          <p>{v.name}</p>
        </div>
        <div style={{ width: "5%" }}>
          <i className={"ui icon caret right"} />
        </div>
      </div>
    ));
  }

  renderLoginCat() {
    return (
      this.state.LoginSub && (
        <div
          onMouseOver={() => this.activeLogin()}
          className={"divCategoria"}
          style={{
            position: "absolute",
            right: "3%",
            justifyContent: "space-between",
            width: "12vw",
            backgroundColor: "#f7f8fa",
          }}
        >
          <div
            style={{ display: "flex", flexDirection: "column" }}
            onMouseLeave={() => this.inactiveLogin()}
          >
            <div
              className="name-category"
              onClick={() => (window.location.href = "/login")}
            >
              <p>Aluno Voitto</p>
            </div>
            <div
              className="name-category"
              onClick={() => (window.location.href = "/login")}
            >
              <p>Universidade Corporativa</p>
            </div>
          </div>
        </div>
      )
    );
  }

  returnSubCategoria() {
    return separa_em_area_corporativa(
      this.state.cursos,
      this.state.menu_categoria
    ).map((v) => {
      return (
        <a
          target="_blank"
          className="item-subcategoria"
          href={`/digital/${v.url_amigavel}`}
          style={{
            color: "black!important",
            display: "flex",
            lineHeight: 1.2,
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            padding: 0,
            margin: 0,
          }}
        >
          <p style={{ color: "black" }}>{limpar_titulo(v.titulo)}</p>
        </a>
      );
    });
  }

  changeColor() { }

  navOpen() {
    if (this.state.open_menu) {
      this.setState({ display: "block" }, () => {
        setTimeout(() => {
          for (var i = 0; i < 20; i++) {
            this.setState({
              width: i + "%",
            });
          }
        }, 50);
      });
      this.setState({ open_menu: false });
    } else {
      for (var i = 20; i > 0; i--) {
        this.setState({
          width: i + "%",
        });
      }
      setTimeout(() => {
        this.setState({ open_menu: true, display: "none" });
      }, 300);
    }
  }

  componentWillMount() {
    const userNode = getUserNode();

    if(!window.location.href.includes("/pagar/")){
      IS_EMPRESA_SET(userNode.gestorEmpresa);
  
      if (userNode.empresa) {
        if (userNode.aluno_empresa && userNode.empresa.id !== 10705) {
          window.location.href = `/universidade/${userNode.empresa.url}`;
        }
        if (userNode.gestorEmpresa) {
          window.location.href = `/painelempresa/${userNode.empresa.url}`;
        }
      }
    }
    else{
      localStorage.setItem("IS_EMP_PAYMENT", true);
      IS_EMPRESA_SET(false);
    }

  }

  componentDidMount() {
    if (isAuthenticatedNode()) {
      this.loadingRecomendados();

      const userNode = getUserNode();
      if (userNode) {
        this.setState({
          id: userNode.id,
          nome: userNode.nome,
          foto: userNode.foto,
          email: userNode.email,
          load: true,
        });
      }

      if (!this.props.id_duvida) {
        producaov2
          .get("/ticket/duvidas/notseen", {
            headers: {
              access_token: `voitto-token ${localStorage.getItem(
                "oauth_token"
              )}`,
            },
          })
          .then((res) => {
            this.setState({ notSeenQuestion: res?.data?.notSeen });
          })
          .catch((err) => console.error("ERR", err));
        return;
      }

      producaov2
        .put(`/ticket/duvida/${this.props.id_duvida}`, { visualizada: 1 })
        .then(() => {
          producaov2
            .get("/ticket/duvidas/notseen", {
              headers: {
                access_token: `voitto-token ${localStorage.getItem(
                  "oauth_token"
                )}`,
              },
            })
            .then((res) => {
              this.setState({ notSeenQuestion: res?.data?.notSeen });
            })
            .catch((err) => console.error("ERR", err));
        })
        .catch((err) => {
          console.error(err);
          producaov2
            .get("/ticket/duvidas/notseen", {
              headers: {
                access_token: `voitto-token ${localStorage.getItem(
                  "oauth_token"
                )}`,
              },
            })
            .then((res) => {
              this.setState({ notSeenQuestion: res?.data?.notSeen });
            })
            .catch((err) => console.error("ERR", err));
        });
    }
  }

  Open_URL = (URL) => {
    window.location.href = URL;
  };

  DropdownExampleDropdown = () => (
    <Dropdown
      id="hs"
      text={abrevia_nome(this.state.nome)}
      style={{
        zIndex: "999999",
        height: "fit-content",
        maxHeight: "42.5px",
      }}
      className="ui simple dropdown item"
    >
      <Dropdown.Menu style={{ marginRight: "10%", marginLeft: "-45px" }}>
        <Dropdown.Item
          style={{ display: "flex" }}
          onClick={() => this.Open_URL("/online/editar-perfil")}
          icon="edit icon"
          text="Editar Perfil"
        />
        <Dropdown.Item
          style={{ display: "flex" }}
          onClick={() => this.Open_URL("/online/certificados/")}
          icon="student icon"
          text="Certificados"
        />
        <Dropdown.Item
          style={{ display: "flex" }}
          onClick={() => this.Open_URL("/online/pedidos")}
          icon="shopping cart icon"
          text="Histórico de Compras"
        />
        <Dropdown.Item
          style={{ display: "flex" }}
          onClick={() => this.Open_URL("/minhas-duvidas")}
          icon="question icon"
          text="Minhas Dúvidas"
        />
        <Dropdown.Item
          style={{ display: "flex" }}
          onClick={() => this.Open_URL("/online/indique-e-ganhe")}
          icon="handshake icon"
          text="Indique e Ganhe"
        />

        {this.state.notSeenQuestion ? <QuestionsNumberUsersBlock /> : null}

        <Dropdown.Item
          style={{ display: "flex" }}
          onClick={() => this.Open_URL("/online/meuscupons/")}
          icon="tag icon mostarPremio"
          text="Cupons"
        />
        {IS_ADMIN() ? (
          <Dropdown.Item
            style={{ display: "flex" }}
            onClick={() => this.Open_URL("/admin/")}
            text="Painel Administrativo"
          />
        ) : null}
        {IS_EMPRESA()
          ? this.state.is_empresa.map((v, i) => (
            <Dropdown.Item
              style={{ display: "flex" }}
              onClick={() => this.Open_URL("/painelempresa/" + v.url)}
              text={"Painel " + v.nome}
            />
          ))
          : null}
        <Dropdown.Item
          style={{ display: "flex" }}
          onClick={() => this.handleSignOut()}
          icon="sign out alternate icon"
          text="Sair"
        />
      </Dropdown.Menu>
    </Dropdown>
  );

  VerificaFoto() {
    if (
      getUserNode().foto == "" ||
      getUserNode().foto == null ||
      getUserNode().foto == 0 ||
      getUserNode().foto == undefined ||
      getUserNode().foto == "0" ||
      getUserNode().foto ==
      "https://files.voitto.com.br/ftp-files/assets/images/user_default.png"
    ) {
      return (
        "https://files.voitto.com.br/ftp-files/assets/images/perfil/" +
        getUserNode().nome.charAt(0).toUpperCase() +
        ".png"
      );
    } else {
      return getUserNode().foto;
    }
  }

  bar_foto() {
    const { load } = this.state;

    if (load)
      return (
        <div
          style={{
            marginLeft: "10%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
          tabIndex="0"
          id="dropper"
        >
          <img
            className="ui avatar circular image user-profile-foto"
            alt="Perfil"
            src={this.VerificaFoto()}
          />
          {this.state.notSeenQuestion ? <QuestionsNumberBlock /> : null}

          {this.DropdownExampleDropdown()}
        </div>
      );
    else return <div> </div>;
  }

  activeCategorias() {
    this.setState({
      actCategorias: true,
    });
  }

  inactiveCategorias() {
    let container = document.getElementById("categoriasContainer");
    let containerSubs = document.getElementById("cursosByCat");
    if (
      (container.parentElement !== null &&
        container.parentElement.querySelector(":hover") === container) ||
      (containerSubs.parentElement !== null &&
        containerSubs.parentElement.querySelector(":hover") === containerSubs)
    ) {
    } else {
      this.setState({
        actCategorias: false,
        cursosByCat: false,
      });
    }
  }

  activeCursosByCat(menu_categoria = 0) {
    this.setState({
      cursosByCat: true,
      menu_categoria,
    });
  }

  activeLogin() {
    this.setState({
      LoginCat: true,
    });
  }

  inactiveLogin() {
    this.setState({
      LoginCat: false,
    });
  }

  handleLogin() {
    localStorage.setItem("redirect", window.location.pathname);
    window.location.href = "/login";
  }

  inactiveCursosByCat() {
    let container = document.getElementById("categoriasContainer");
    let containerSubs = document.getElementById("cursosByCat");
    if (
      (container.parentElement !== null &&
        container.parentElement.querySelector(":hover") === container) ||
      (containerSubs.parentElement !== null &&
        containerSubs.parentElement.querySelector(":hover") === containerSubs)
    ) {
    } else {
      this.setState({
        cursosByCat: false,
        actCategorias: false,
      });
    }
  }
  render() {
    if (verify_mobile()) {
      return <TopoMobileNode load={this.state.load} />;
    } else {
      if (!isAuthenticatedNode())
        return (
          <div
            style={{
              height: 50,
              top:
                window.location.href.indexOf("inscricao") < 0
                  ? this.props.topper
                  : 0,
              backgroundColor: "#030303",
              zIndex: 9999999999,
            }}
            className="ui inverted black top fixed menu transition grid computer only toposss"
          >
            <div
              style={{
                width: "95%",
                marginLeft: "2.5%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div
                onClick={this.navOpen.bind(this)}
                style={{ border: "none", cursor: "pointer", marginTop: -10 }}
                className="item"
              >
                <i
                  className="ui bars icon"
                  style={{ color: "white", fontSize: 13 }}
                ></i>
              </div>
              <a
                href="/"
                style={{
                  height: "50px",
                  padding: "10px",
                  position: "relative",
                  right: "0%",
                }}
                className="item"
              >
                {getUserNode().premium ? (
                  <img
                    className="ui item  premium"
                    src="https://files.voitto.com.br/ftp-files/assets/images/logo_premium.png"
                    style={{
                      border: "none",
                      width: 90,
                      marginTop: 10,
                      marginRight: -18,
                      objectFit: "contain",
                    }}
                    alt="Voitto"
                  />
                ) : (
                  <img
                    className="ui item logo  droppedsda"
                    style={{
                      border: "none",
                      width: 90,
                      marginTop: 10,
                      marginRight: 18,
                      objectFit: "contain",
                    }}
                    src="https://files.voitto.com.br/ftp-files/assets/images/voitto-white-full.png?size=200"
                    alt="Voitto"
                  />
                )}
              </a>
              <div
                onClick={() => {
                  window.open("/cursos", "_blank");
                }}
                onMouseOver={this.activeCategorias}
                onMouseOut={this.inactiveCategorias}
                style={{
                  height: "50px",
                  padding: "10px",
                  right: "1%",
                  position: "relative",
                  left: "0.2%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                className="item"
              >
                <p
                  style={{
                    fontSize: 14,
                    fontWeight: 700,
                    position: "relative",
                    right: 5,
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  Cursos
                </p>
              </div>
              <a
                href="/ao-vivo"
                style={{
                  height: "50px",
                  padding: "10px",
                  position: "relative",
                  right: "0.8%",
                }}
                className="item"
              >
                <img
                  className="ui item logo  droppedsda"
                  style={{
                    border: "none",
                    width: 90,
                    marginTop: 10,
                    marginRight: 18,
                    objectFit: "contain",
                  }}
                  src="https://files.voitto.com.br/aovivoIcon.png"
                  alt="Voitto"
                />
              </a>
              <div id="div_input2">
                <form
                  action="/busca"
                  style={{ width: "103%" }}
                  onSubmit={(e) => {
                    if (document.getElementById("menu_input").value == "") {
                      e.preventDefault();
                    }
                  }}
                >
                  <input
                    id="menu_input"
                    onKeyUp={(e) => {
                      if (e.keyCode == 13 && e.target.value !== "") {
                        window.location.href = `/busca?filter=${e.target.value}`;
                      }
                    }}
                    name="filter"
                    style={{
                      width: "100%",
                    }}
                    className="portalSearchAntigo noti-searchAntigo load_aovivo load_voittocasts load_artigos load_materiais"
                    type="text"
                    placeholder="O que você quer aprender hoje?"
                  />
                  <button
                    style={{ backgroundColor: "transparent", border: "none" }}
                    type="submit"
                  >
                    <i className="inverted circular search link icon submit-pesquisa"></i>
                  </button>
                </form>
              </div>
              <div>
                <span
                  style={{ marginLeft: "3%" }}
                  id="dropper"
                  className="item"
                >
                  <button
                    className="ui inverted button sing-in-btn"
                    onClick={() => this.handleLogin()}
                    style={{ borderRadius: 0, fontWeight: "900" }}
                  >
                    <b style={{ display: "flex" }}>Entrar </b>
                  </button>
                </span>
              </div>

              <div
                onClick={this.navOpen.bind(this)}
                id="mySidenavToRight "
                style={{
                  width: this.state.width,
                  display: this.state.display,
                  zIndex: 9999999999,
                }}
                className="sidenavToRight"
              >
                <div
                  style={{ display: "flex",marginTop: -20, marginBottom: -5  }}
                  className="content-menu-left"
                >
                  <a href="/" style={{ height: 80 }}>
                    <img
                      className="ui item logo droppedsda"
                      style={{
                        border: "none",
                        width: 90,
                        marginTop: "10px !important",
                        marginRight: -18,
                        objectFit: "contain",
                      }}
                      src="https://files.voitto.com.br/ftp-files/assets/images/voitto-white-full.png?size=200"
                      alt="Voitto"
                    />
                  </a>
                  <i
                    style={{ zIndex: 9999999999, color: "white" }}
                    className="ui white icon close"
                  ></i>
                </div>
                <a
                  style={{ display: "flex", flexDirection: "row" }}
                  href="/sobrenos"
                >
                  <p style={{ color: "white", fontSize: "13px" }}>
                    <i className="ui icon book"></i>Sobre nós
                  </p>
                </a>
                <a style={{ display: "flex" }} href="/cursos">
                  <p style={{ color: "white", fontSize: "13px" }}>
                    <i className="ui icon play"></i> Treinamentos
                  </p>
                </a>
                <a style={{ display: "flex" }} href="/ao-vivo">
                  <p style={{ color: "white", fontSize: "13px" }}>
                    <i className="ui icon red circle"></i> Lives
                  </p>
                </a>
                <a
                  style={{ display: "flex" }}
                  href="/workshops"
                  onClick={this.props.changeAbaNode.bind(this, "workshops")}
                >
                  <p style={{ color: "white", fontSize: "13px" }}>
                    <i className="ui icon archive"></i> Workshops
                  </p>
                </a>

                <a
                  style={{ display: "flex", flexDirection: "row" }}
                  href="/certificacao/certificacao-green-e-black-belt-em-lean-seis-sigma"
                >
                  <p style={{ color: "white", fontSize: "13px" }}>
                    <i className="ui icon certificate"></i> Certificações
                  </p>
                </a>
                <a style={{ display: "flex" }} href="/voitto-partners">
                  <p style={{ color: "white", fontSize: "13px" }}>
                    <i className="ui icon handshake"></i> Parcerias
                  </p>
                </a>
                <a style={{ display: "flex" }} href="/historias-de-sucesso">
                  <p style={{ color: "white", fontSize: "13px" }}>
                    <i className="ui icon star"></i> Histórias de Sucesso
                  </p>
                </a>
                <a style={{ display: "flex" }} href="/blog">
                  <p style={{ color: "white", fontSize: "13px" }}>
                    <i className="ui icon globe"></i> Conteúdos Gratuitos
                  </p>
                </a>
                <a style={{ display: "flex" }} href="/faq">
                  <p style={{ color: "white", fontSize: "13px" }}>
                    <i className="ui icon comments outline"></i> Central de
                    Ajuda
                  </p>
                </a>
                <a style={{ display: "flex" }} href="/empresas">
                  <p style={{ color: "white", fontSize: "13px" }}>
                    <i className="ui icon building"></i> Atendimento à Empresas
                  </p>
                </a>
              </div>
            </div>
            {this.state.actCategorias ? (
              <div
                id="categoriasContainer"
                style={{
                  top:
                    window.location.href.indexOf("inscricao") < 0
                      ? parseInt(this.props.topper) + 50
                      : 0 + 50,
                }}
                onMouseOut={this.inactiveCategorias}
                className={"categoriasContainer contMenuNovo"}
              >
                {this.renderCategorias()}
              </div>
            ) : (
              <div id="categoriasContainer" className="contMenuNovo"></div>
            )}
            {this.state.cursosByCat ? (
              <div
                id="cursosByCat"
                style={{
                  top:
                    window.location.href.indexOf("inscricao") < 0
                      ? this.props.topper + 50
                      : 0 + 50,
                }}
                onMouseOut={this.inactiveCursosByCat}
                className={"cursosByCat contMenuNovo"}
              >
                {this.returnSubCategoria()}
              </div>
            ) : (
              <div id="cursosByCat" className="contMenuNovo"></div>
            )}
          </div>
        );
      else
        return (
          <div
            style={{
              height: 50,
              top:
                window.location.href.indexOf("inscricao") < 0
                  ? this.props.topper
                  : 0,
              backgroundColor: "#030303",
              zIndex: 9999999999,
            }}
            className="ui inverted black top fixed menu transition grid computer only toposss"
          >
            <div
              style={{
                width: "95%",
                marginLeft: "2.5%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div
                onClick={this.navOpen.bind(this)}
                style={{ border: "none", cursor: "pointer", marginTop: -10 }}
                className="item"
              >
                <i
                  className="ui bars icon"
                  style={{ color: "white", fontSize: 13 }}
                ></i>
              </div>
              <a
                href="/"
                style={{ marginTop: -15, marginLeft: -11, marginRight: 5 }}
                className="item"
              >
                {getUserNode().premium ? (
                  <img
                    className="ui item logo premium"
                    src="https://files.voitto.com.br/ftp-files/assets/images/logo_premium.png"
                    style={{ width: "140px" }}
                    alt="Voitto"
                  />
                ) : (
                  <img
                    className=""
                    style={{
                      border: "none",
                      width: 60,
                      marginTop: 10,
                      objectFit: "contain",
                    }}
                    src="https://files.voitto.com.br/ftp-files/assets/images/voitto-white-full.png?size=200"
                    alt="Voitto"
                  />
                )}
              </a>
              <div id="div_input">
                <form
                  action="/busca"
                  onSubmit={(e) => {
                    if (document.getElementById("menu_input").value == "") {
                      e.preventDefault();
                    }
                  }}
                  style={{ width: "103%" }}
                >
                  <input
                    name="filter"
                    onKeyUp={(e) => {
                      if (e.keyCode == 13 && e.target.value !== "") {
                        window.location.href = `/busca?filter=${e.target.value}`;
                      }
                    }}
                    id="menu_input"
                    className="portalSearchAntigo noti-searchAntigo load_aovivo load_voittocasts load_artigos load_materiais"
                    type="text"
                    placeholder="O que você quer aprender hoje?"
                  />
                  <button
                    style={{ backgroundColor: "transparent", border: "none" }}
                    type="submit"
                  >
                    <i className="inverted circular search link icon submit-pesquisa"></i>
                  </button>
                </form>
              </div>

              <VoittoCoins />
              {this.state.id && (
                <ItemContent
                  small
                  onMouseEnter={() =>
                    this.setState({ notificationsBlock: true })
                  }
                  onMouseLeave={() =>
                    this.setState({ notificationsBlock: false })
                  }
                >
                  <FaBell size={24} />

                  {this.state.unreadedNotifications !== 0 && (
                    <NotificationsNumberBlock>
                      {this.state.unreadedNotifications}
                    </NotificationsNumberBlock>
                  )}

                  <NotificationsBlock
                    active={this.state.notificationsBlock}
                    handlerUnreadedNotifications={(unreadedNotifications) =>
                      this.setState({ unreadedNotifications })
                    }
                  />
                </ItemContent>
              )}
              {this.bar_foto()}
              <div
                onClick={this.navOpen.bind(this)}
                id="mySidenavToRight"
                style={{ width: this.state.width, display: this.state.display }}
                className="sidenavToRight"
              >
                <div
                  style={{ display: "flex",marginTop: -20, marginBottom: -5 }}
                  className="content-menu-left"
                >
                  {this.state.is_premium == 1 ? (
                    <a href="/">
                      <img
                        className="ui item logo"
                        style={{
                          border: "none",
                          width: 150,
                          marginTop: 10,
                          marginRight: -18,
                          objectFit: "contain",
                        }}
                        src="https://files.voitto.com.br/ftp-files/assets/images/logo_premium.png"
                        alt="Voitto"
                      />
                    </a>
                  ) : (
                    <a href="/" style={{ height: 80 }}>
                      <img
                        className="ui item logo"
                        style={{
                          border: "none",
                          width: 90,
                          marginTop: 10,
                          marginRight: -18,
                          objectFit: "contain",
                        }}
                        src="https://files.voitto.com.br/ftp-files/assets/images/voitto-white-full.png?size=200"
                        alt="Voitto"
                      />
                    </a>
                  )}
                  <i
                    style={{ zIndex: 9999999999, color: "white" }}
                    className="ui white icon close"
                  ></i>
                </div>
                <a
                  style={{ display: "flex", flexDirection: "row" }}
                  href="/sobrenos"
                >
                  <p style={{ color: "white", fontSize: "13px" }}>
                    <i className="ui icon book"></i>Sobre nós
                  </p>
                </a>
                <a style={{ display: "flex" }} href="/cursos">
                  <p style={{ color: "white", fontSize: "13px" }}>
                    <i className="ui icon play"></i> Treinamentos
                  </p>
                </a>
                <a style={{ display: "flex" }} href="/lives">
                  <p style={{ color: "white", fontSize: "13px" }}>
                    <i className="ui icon red circle"></i> Lives
                  </p>
                </a>
                <a style={{ display: "flex" }} href="/workshops">
                  <p style={{ color: "white", fontSize: "13px" }}>
                    <i className="ui icon archive"></i> Workshops
                  </p>
                </a>

                <a
                  style={{ display: "flex", flexDirection: "row" }}
                  href="/certificacao/certificacao-green-e-black-belt-em-lean-seis-sigma"
                >
                  <p
                    style={{
                      color: "white",
                      fontSize: "13px",
                      marginRight: "2px",
                    }}
                  >
                    <i className="ui icon certificate"></i> Certificações
                  </p>
                </a>
                <a style={{ display: "flex" }} href="/voitto-partners">
                  <p style={{ color: "white", fontSize: "13px" }}>
                    <i className="ui icon handshake"></i> Parcerias
                  </p>
                </a>
                <a style={{ display: "flex" }} href="/historias-de-sucesso">
                  <p style={{ color: "white", fontSize: "13px" }}>
                    <i className="ui icon star"></i> Histórias de Sucesso
                  </p>
                </a>
                <a style={{ display: "flex" }} href="/blog">
                  <p style={{ color: "white", fontSize: "13px" }}>
                    <i className="ui icon globe"></i> Conteúdos Gratuitos
                  </p>
                </a>
                <a style={{ display: "flex" }} href="/faq">
                  <p style={{ color: "white", fontSize: "13px" }}>
                    <i className="ui icon comments outline"></i> Central de
                    Ajuda
                  </p>
                </a>
                <a style={{ display: "flex" }} href="/empresas">
                  <p style={{ color: "white", fontSize: "13px" }}>
                    <i className="ui icon building"></i> Atendimento à Empresas
                  </p>
                </a>
              </div>
            </div>
            {this.props.topoEmpresa != undefined ? (
              <div style={styleEmpresa.div}>
                <img
                  src={this.props.topoEmpresa.logo}
                  style={styleEmpresa.img}
                />
                <p style={styleEmpresa.p}>
                  Universidade - {this.props.topoEmpresa.nomeEmpresa}
                </p>
              </div>
            ) : null}
          </div>
        );
    }
  }
}

const styleEmpresa = {
  div: {
    width: "100%",
    display: "flex",
    padding: "0.7%",
    // justifyContent: 'space-between',
    paddingLeft: "5%",
    paddingRight: "5%",
    marginTop: "-10px",
    backgroundColor: "rgba(27, 28, 29, 0.85)",
    color: "rgba(255, 255, 255, 0.9)",
    alignItems: "center",
    height: "50px",
  },
  img: {
    border: "none",
    marginLeft: "1.1%",
    width: "140px",
    objectFit: "contain",
    maxHeight: "40px",
    padding: 1,
  },
  p: {
    fontSize: "large",
    fontWeight: "600",
    width: "100%",
    textAlign: "center",
  },
};

const QuestionsNumberBlock = styled.div`
  width: 0.8rem;
  height: 0.8rem;
  background-color: orange;
  position: absolute;
  margin-left: 1.5rem;
  margin-bottom: 0.5rem;
  padding: 0.2rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  color: #fff;
`;

const QuestionsNumberUsersBlock = styled.div`
  width: 0.5rem;
  height: 0.5rem;
  background-color: orange;
  position: absolute;
  left: 1.85rem;
  top: 10.9rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  z-index: 1000000000;
`;

export const ItemContent = styled.div`
  min-width: ${(props) =>
    props.small ? "4rem" : props.big ? "10rem" : "7.5rem"};
  height: 50px;
  color: #fff !important;
  font-weight: 400;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-right: 1px #222 solid;
  transition: 0.2s ease-in-out;
  cursor: pointer;
  position: relative;
  padding: 0 2.5rem;
  text-align: center;

  > a {
    color: #fff !important;
  }

  &:hover {
    background-color: #111;
  }

  @media screen and (max-width: 1100px) {
    min-width: ${(props) => (props.small ? "4rem" : "6rem")};
  }
`;

export const NotificationsNumberBlock = styled.div`
  width: 1.2rem;
  height: 1.2rem;
  background-color: red;
  position: absolute;
  margin-top: -0.6rem;
  margin-left: 0.5rem;
  padding: 0.2rem;
  border-radius: 0 4px 0 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
`;

const mapStateToProps = (store) => ({ myaba: store.home.aba });
const mapDispathToProps = (dispatch) =>
  bindActionCreators({ changeAbaNode }, dispatch);
export default connect(mapStateToProps, mapDispathToProps)(Topo);
